export default __webpack_public_path__ + "static/media/call-to-action-card1.a3d1ede6.png";